import React, { useState, useEffect } from "react";
import DesktopProductCard from "./DesktopProductCard";
import MobileProductCard from "./MobileProductCard";

const ProductCard = ({ product, sequence = 0, isProfessional = false }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? (
    <MobileProductCard
      product={product}
      sequence={sequence}
      isProfessional={isProfessional}
    />
  ) : (
    <DesktopProductCard
      product={product}
      sequence={sequence}
      isProfessional={isProfessional}
    />
  );
};

export default ProductCard;